import React from "react"
import Back from "../common/back/Back"
import TeamCard from "./TeamCard"
import "./team.css"
import Awrapper from "../about/Awrapper"
import "../about/about.css"

const Team = () => {
  return (
    <div>
      <Back title='Team' />
      <section className='team padding'>
        <div>
          <TeamCard />
        </div>
      </section>
      <Awrapper />
    </div>
  )
}

export default Team
